module.exports = __webpack_public_path__ + "img/sq4m_03.2a536324.jpg";